module.exports = __webpack_public_path__ + "img/button_blue_bottom.ded7fe3c.svg";